import { marketingActionsDtos, MarketingActionStore, ProgressStateModel } from 'eTip--common';
import { types, getEnv } from 'mobx-state-tree';
import { IAppEnv } from '../appEnvironment';

export const MarketingActionStoreDesktop = types.compose(
    MarketingActionStore,
    types.model({})
)
    .actions((self) => {
        const env = getEnv<IAppEnv>(self);

        const prepareData = (sourceData: marketingActionsDtos.MarketingActionsResponse | null) => {

            try {
                self.setData(sourceData, env.loggedUserId);
            } catch (error) {
                env.loggingService.error(error);
                self.state = ProgressStateModel.Failed;
                throw error;
            }
        }

        return {
            prepareData
        }
    });